/**
 * Composition methods for PDF viewer module
 * 
 * Author: Andrea López
 */
import { computed, onMounted, ref, inject, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export function pdfComposition () {
    const route = useRoute();
    const router = useRouter();

    const currentPage = ref<number>(1);
    const pageCount = ref<number>(0);
    const loading = ref<boolean>(true);

    const hasPreviousPage = computed(() => {
        return currentPage.value > 1;
    });
    
    const hasNextPage = computed(() => {
        return currentPage.value < pageCount.value;
    });


    // Function to get the current PDF page
    function getPage () {
		const { page } = route.query || {};

		if (page) {
			currentPage.value = parseInt(page as string);
		}
	}
    
    // Function to navigate to specific page
    function evaluateLink (event: any) {
        currentPage.value = event.pageNumber;
	}
    
    function checkNumPages (event: any) {
        pageCount.value = event;
	}

    // Function to navigate to +/- pages
    function goTo (amount: number) {
		currentPage.value += amount;
	}

    function goBack () {
        router.go(-1);
    }

    onMounted(() => {
        getPage();
    });

    return {
        currentPage, pageCount, hasPreviousPage, hasNextPage,
        getPage, evaluateLink, goTo, checkNumPages, loading,
        goBack
    }
}

export function pdfEndpointComposition () {
	const endpointData = inject<any>('endpointData');
    const isPdfContent = ref<boolean>(false);
    
    function checkPdfType () {
        const { type } = endpointData.value;
        isPdfContent.value = type === 'pdf';
    }
    
    watchEffect(() => {
        checkPdfType();
    })

    onMounted(() => {
        checkPdfType();
    })

    return { isPdfContent, endpointData }
}